import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../css/Footer.css";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer tech-footer py-4">
      <Container className="text-center d-flex flex-column flex-md-row justify-content-md-between align-items-center gap-2">

        <span className="footer-text">
          &copy; {year} JACAi • All rights reserved
        </span>

        <div className="footer-links d-flex gap-3">
          <Link to="/privacy-policy" className="footer-link">
            Privacy Policy
          </Link>

          <Link to="/terms-of-use" className="footer-link">
            Terms of Use
          </Link>
        </div>

      </Container>
    </footer>
  );
}